// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Customer extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get displayName() {
        if (!!this.companyName && !!this.contactName) return `${this.companyName} - ${this.contactName}`;
        if (!!this.companyName) return this.companyName;
        if (!!this.contactName) return this.contactName;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  billAddress1?: string;
  billAddress2?: string;
  billCity?: string;
  billCountry?: string;
  billCountryOther?: string;
  billState?: string;
  billZip?: string;
  companyName?: string;
  contactName?: string;
  deleted?: Date;
  email?: string;
  firstName?: string;
  lastName?: string;
  phone1?: string;
  phone2?: string;
  shipToAddress1?: string;
  shipToAddress2?: string;
  shipToCity?: string;
  shipToCountry?: string;
  shipToState?: string;
  shipToZip?: string;
}

